var _path, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "f7651d76-ee00-4083-9c64-2796abaebea1",
    "data-name": "Layer 1",
    width: 45,
    height: 34.6149,
    viewBox: "0 0 45 34.6149",
    fill: "orange",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1,.7692V35.3841H46V.7692Zm43.06.9575L23.5,16.3357,2.9391,1.7267Zm-42.1029,32.7V2.2038L23.5,17.51,45.0425,2.2042V34.4266Z",
    transform: "translate(-1 -0.7692)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.6152,
    y: 24.3289,
    width: 10.9615,
    height: 0.9575
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.6152,
    y: 28.3672,
    width: 5.7695,
    height: 0.9574
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.fcb1a01bf9c8827795a4239483264867.svg";
export { ForwardRef as ReactComponent };